export {default} from "./LoundriesTemplate"